export const authorities = {
  BETA_DEALER: 'BETA_DEALER',
  BILLING: 'BILLING',
  CREATE_ADMIN: 'CREATE_ADMIN',
  CREATE_DEALER: 'CREATE_DEALER',
  MANAGE_ADMIN: 'MANAGE_ADMIN',
  MANAGE_BLACKLIST: 'MANAGE_BLACKLIST',
  MANAGE_DEALER: 'MANAGE_DEALER',
  MANAGE_MY_DEALERS: 'MANAGE_MY_DEALERS',
  MANAGE_LEAD: 'MANAGE_LEAD',
  MANAGE_MY_NETWORK: 'MANAGE_MY_NETWORK',
  MANAGE_VEHICLE: 'MANAGE_VEHICLE',
  MANAGE_VEHICLE_STATE: 'MANAGE_VEHICLE_STATE',
  READ_MY_NETWORK: 'READ_MY_NETWORK',
  UPDATE_LEAD_SALE: 'UPDATE_LEAD_SALE',
};

export const roles = {
  BRANCH_ADMIN: 'BRANCH_ADMIN',
  BRANCH_BASIC: 'BRANCH_BASIC',
  NETWORK_ADMIN: 'NETWORK_ADMIN',
  NONE: 'NONE',
};

// agree to cookie consent
export const SET_AGREE_TO_ALL = 'SET_AGREE_TO_ALL';

export const getReduxCachePrefix = feature => {
  return `@@CACHE:${feature}::`;
};

export const DEALER_FEATURES = {
  LISTINGS: 'LISTINGS',
};
